import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IBilling, ICallState, IIncomingMessage, IMediaServerMap } from './types'

const callSlice = createSlice({
    name: 'call',
    initialState: {
        status: ({} as any) as string,
        incomingMessage: ({} as any) as IIncomingMessage,
        callState: ({} as any) as ICallState,
        callAvailable: true,
        billing: ({} as any) as IBilling,
        logout: false,
        uniqueDeviceId: ({} as any) as string,
        mediaServerMap: ([{}] as any) as IMediaServerMap[],
        botCallTranscript: ([] as any) as any[],
        updateCallTranscript: ({} as any),
        updateAISummarization:({} as any)
    },
    reducers: {
        callStateChanged: (state, action: PayloadAction<ICallState>) => {
            state.callState = action.payload
        },
        callIncomingMessageReceived: (state, action: PayloadAction<IIncomingMessage>) => {

            console.log("INCOMING CALL MESSAGE", action.payload)
            if (action.payload.msg_type == "INCOMINGCALL" && state.incomingMessage.msg_type == "INCOMINGCALL" && action.payload.call_id && state.incomingMessage.call_id && state.incomingMessage.call_id !== action.payload.call_id)
                return
            console.log("callIncomingMessageReceived", action.payload.msg_type, !state.callState.isCalling);
            if (action.payload.msg_type || !state.callState.isCalling) {
                state.incomingMessage = action.payload
                if (action.payload.username) {
                    const clearUsername = action.payload.username.charAt(0) === "+" ? action.payload.username.substring(1) : action.payload.username;
                    const replacedUsername = clearUsername.charAt(0) === "0" ? "62" + clearUsername.substring(1) : clearUsername;
                    state.incomingMessage.username = replacedUsername
                }
            }
        },
        billingIncomingMessageReceived: (state, action: PayloadAction<IBilling>) => {
            state.billing = action.payload
        },
        logoutIncomingMessageReceived: (state, action: PayloadAction<boolean>) => {
            console.log("updating logout", action.payload)
            state.logout = action.payload
        },
        billingCleared: (state) => {
            state.billing = ({} as any) as IBilling
        },
        callSocketOpened: (state) => {

            console.log("connected to SIP server")
            state.status = "connected";
        },
        callSocketClosed: (state) => {
            state.status = "disconnected"
        },
        callWSStartConnecting: (state) => {
            state.status = "connecting..."
        },
        callWSDisconnect: (state) => {
            state.status = "disconnecting..."
        },
        callSendMessage: (state, action: PayloadAction<{ content: string }>) => {
            return;
        },
        callSetAvailable: (state, action: PayloadAction<boolean>) => {
            state.callAvailable = action.payload
        },
        callSetUniqueDeviceId: (state, action: PayloadAction<string>) => {
            state.uniqueDeviceId = action.payload
        },
        setMediaServerList: (state, action: PayloadAction<any>) => {
            state.mediaServerMap = action.payload
        },
        setBotCallTranscript: (state, action: PayloadAction<any>) => {
            state.botCallTranscript = action.payload
        },
        callTranscriptRefreshData: (state, action: PayloadAction<any>) => {
            state.updateCallTranscript = action.payload
        },
        aiSummarizationRefreshData: (state, action: PayloadAction<any>) => {
            state.updateAISummarization = action.payload
        },
    },
})

export default callSlice.reducer
export const {
    callStateChanged
    , callIncomingMessageReceived
    , callSocketOpened
    , callSocketClosed
    , callWSStartConnecting
    , callWSDisconnect
    , callSendMessage
    , callSetAvailable
    , billingIncomingMessageReceived
    , billingCleared
    , callSetUniqueDeviceId
    , logoutIncomingMessageReceived
    , setMediaServerList
    , setBotCallTranscript
    , callTranscriptRefreshData
    , aiSummarizationRefreshData
} = callSlice.actions

